import { observable, action, computed } from 'mobx'
import PT from 'prop-types'
import logger from '@vimcar/shared-utils/logger'

import i18n from '#utils/i18n'
import { O } from '#utils/rx'
import { errorCodes, getErrorCode } from '#utils/foxboxErrors'

const tp = i18n.prefix('components.EditEmailDialog')

const EditEmailDialog = (
  { registerObservable },
  { onClose },
  { users },
) => {
  const store = observable({
    step: 1,
    showForm: computed(() => store.step === 1),
    showDone: computed(() => store.step === 2),
    fields: observable.ref(['newEmail', 'password']),
    currentEmail: computed(() => users.self.email),
    data: observable.ref({
      newEmail: '',
      password: '',
    }),
    handleSubmit: action(({ password, newEmail }) => {
      registerObservable(
        users.self.updateEmail(
          newEmail,
          password
        )
          .catch(action((err) => {
            const errCode = getErrorCode(err)
            switch (errCode) {
              case errorCodes.PASSWORD_WRONG:
              case errorCodes.PASSWORD_DOES_NOT_MATCH:
                store.error = tp('auth-failed')
                break
              case errorCodes.EMAIL_ALREADY_EXISTS:
                store.error = tp('email-already-exists')
                break
              default:
                logger.error(err)
                store.error = tp('update-failed')
                break
            }
            return O.empty()
          }))
          .do(action(() => {
            store.step = 2
          }))
      )
    }),
    handleClickClose: action(() => {
      onClose()
    }),
  })

  return store
}

EditEmailDialog.propTypes = {
  onClose: PT.func.isRequired,
}

EditEmailDialog.contextTypes = {
  users: PT.object.isRequired,
}

export default EditEmailDialog
